<div class="panel-body ">
    <div class="image-col">
        <img [src]="mobileImagePath" class="img-fluid" alt=""/>
    </div>
    <div class='panel-text-wrapper'>
        <p class="heading-4">{{translationRoot + '.body' | translate:useLocaleOverride}}</p>
        <button *ngIf="componentData.includeCallToAction" type="button"
                class="button button-large {{buttonType}} secondary-blue" (click)="callToActionClick(callToActionUrl)">
            {{translationRoot + '.button' | translate:useLocaleOverride}}
        </button>
    </div>
</div>
